"use client"

import { usePathname, useRouter } from "next/navigation"
import React, { useEffect } from "react"

import { scroller } from "@/hooks/useScroll"
import SubNav from "@/ui/patterns/SubNav"

const StablecoinLayout: React.FC<any> = ({ children }) => {
  const router = useRouter()
  const pathName = usePathname()
  // Effect to handle scrolling to the section based on the hash
  useEffect(() => {
    const currentHash = window.location.hash.replace("#", "")
    if (currentHash) {
      scroller.scrollTo(currentHash, {
        smooth: true,
        duration: 800,
        offset: -100, // Adjust based on your header size
      })
    }
  }, [])

  const parentLink = "Ripple USD"

  const menuLinks = [
    {
      text: "Overview",
      location: "/solutions/stablecoin/", // No onClick needed, just the default link
    },
    {
      text: "Transparency",
      location: "/solutions/stablecoin/transparency/", // No onClick needed
    },
    {
      text: "Advisory Board",
      location: "/solutions/stablecoin/advisory-board/", // No onClick needed
    },
    {
      text: "Developers",
      location: "/solutions/stablecoin/#developers",
      onClick: () => {
        const path = "/solutions/stablecoin/"
        const hash = "developers"
        // Set the hash to scroll to after navigation
        if (pathName === path) {
          // Already on the page, scroll directly
          scroller.scrollTo(hash, {
            smooth: true,
            duration: 800,
            offset: -100,
          })
        } else {
          // Navigate to the page with the hash in the URL
          router.push(`/solutions/stablecoin#${hash}`)
        }
      },
    },
  ]

  return (
    <div className="bg-white-100">
      <SubNav menuLinks={menuLinks} parentLink={parentLink} mode="light" />
      {children}
    </div>
  )
}

export default StablecoinLayout
